import { COUNTRIES } from '@ben/common/countries';
import type { ISelectOption } from '@ben/orion/deprecated-select';

const contactTypeField = {
  name: 'Relationship',
  key: 'contactType',
  type: 'DROPDOWN',
  showLabel: true,
  placeholder: 'Please select...',
};
export const otherPersonFields = [
  {
    name: 'First Name',
    key: 'firstName',
    type: 'TEXT_INPUT',
    showLabel: true,
  },
  {
    name: 'Last Name',
    key: 'lastName',
    type: 'TEXT_INPUT',
    showLabel: true,
  },
  {
    name: 'Legal Sex',
    key: 'gender',
    showLabel: true,
    type: 'DROPDOWN',
    placeholder: 'Please select...',
    options: [
      {
        key: 'MALE',
        label: 'Male',
      },
      {
        key: 'FEMALE',
        label: 'Female',
      },
    ] as ISelectOption[],
  },
  {
    name: 'Date of birth',
    key: 'dob',
    type: 'DATE_INPUT',
    showName: true,
    placeholder: 'Select date (DD/MM/YYYY)',
    dateFormat: 'dd/MM/yyyy',
    maxDate: new Date(),
  },
  {
    name: 'SOCIAL SECURITY / NI NO.',
    key: 'ssn',
    type: 'TEXT_INPUT',
    showLabel: true,
    placeholder: 'Do not use spaces',
    maxLength: 20,
  },
  {
    label: 'Nationality',
    key: 'nationality',
    type: 'DROPDOWN',
    placeholder: 'Please select...',
    options: COUNTRIES.map((country) => ({
      key: country.alpha_2_code,
      label: country.en_short_name,
    })),
  },
  {
    label: 'This person lives at my home address',
    key: 'addressSameAsHomeAddress',
    type: 'CHECKBOX',
  },
];

export enum AcceptedContact {
  SPOUSE = 'SPOUSE',
  CHILD = 'CHILD',
  OTHER = 'OTHER',
  FRIEND = 'FRIEND',
}

const ContactTypeLabel = {
  [AcceptedContact.SPOUSE]: 'Spouse / Partner',
  [AcceptedContact.CHILD]: 'Child',
  [AcceptedContact.OTHER]: 'Other',
  [AcceptedContact.FRIEND]: 'Friend',
};

const getContactTypeOptions = (acceptedContactTypes: AcceptedContact[]) => {
  return acceptedContactTypes.map((contactType) => ({
    key: contactType,
    label: ContactTypeLabel[contactType] ?? contactType,
  })) as ISelectOption[];
};

export const getPersonFieldMap = (acceptedContactTypes: AcceptedContact[]) => {
  if (
    !acceptedContactTypes ||
    !Array.isArray(acceptedContactTypes) ||
    acceptedContactTypes.length === 0
  )
    return otherPersonFields;
  const options = getContactTypeOptions(acceptedContactTypes);
  return [
    {
      ...contactTypeField,
      options,
    },
    ...otherPersonFields,
  ];
};
